import { forwardRef } from "react"
import { IconCirclePlusOutline18 as DiamondPlus } from "nucleo-ui-outline-18"

import type { ButtonProps } from "@productlane/ui"
import { cn } from "@productlane/lib/src/cn"
import { Button } from "@productlane/ui"

interface SidebarAddButtonProps extends Omit<
	ButtonProps,
	"Icon" | "variant" | "children"
> {
	label: string
	visible?: boolean
	hoverGroup?: "sidebar" | "views" | "nav"
}

const HOVER_CLASSES = {
	sidebar: "group-hover/sidebar:opacity-100",
	views: "group-hover/views:opacity-100",
	nav: "group-hover/nav:opacity-100",
} as const

export const SidebarAddButton = forwardRef<
	HTMLButtonElement,
	SidebarAddButtonProps
>(({ label, visible, hoverGroup = "sidebar", className, ...rest }, ref) => {
	return (
		<Button
			ref={ref}
			variant="ghost"
			Icon={DiamondPlus}
			iconClassName="h-3.5 w-3.5 [&_*]:[stroke-width:1px]"
			className={cn(
				"w-full justify-start gap-2 truncate py-1.5 pl-2.5 pr-2 text-xs !text-tertiary transition-opacity",
				visible
					? "opacity-100"
					: cn(
							"opacity-0 focus-visible:opacity-100",
							HOVER_CLASSES[hoverGroup],
						),
				className,
			)}
			{...rest}
		>
			{label}
		</Button>
	)
})
